document.addEventListener("DOMContentLoaded", () => {
  // Elements
  const filterButtons = document.querySelectorAll(".filter-btn");
  const galleryItems = document.querySelectorAll(".gallery-item");
  const galleryImages = document.querySelectorAll(".gallery-item img");
  const lightbox = document.getElementById("lightbox");
  const lightboxImg = document.getElementById("lightbox-img");
  const lightboxCaption = document.getElementById("lightbox-caption");
  const lightboxClose = document.getElementById("lightbox-close");

  // Filter Functionality
  function filterGallery(filter) {
    galleryItems.forEach((item) => {
      const category = item.dataset.category;
      if (filter === "all" || category === filter) {
        item.style.display = "block";
        setTimeout(() => item.classList.add("visible"), 50); // Fade-in effect
      } else {
        item.classList.remove("visible");
        setTimeout(() => (item.style.display = "none"), 200); // Fade-out effect
      }
    });
  }

  filterButtons.forEach((button) => {
    button.addEventListener("click", () => {
      // Remove active class from all buttons and add to the clicked one
      filterButtons.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      // Apply filter
      const filter = button.getAttribute("data-filter");
      filterGallery(filter);
    });
  });

  // Lightbox Functionality
  function openLightbox(img) {
    lightbox.style.display = "flex";
    lightboxImg.src = img.src; // Set the lightbox image to the clicked image

    // Retrieve and set caption
    const parent = img.closest(".gallery-item");
    const caption = parent.querySelector(".overlay").textContent.trim();
    lightboxCaption.textContent = caption;
  }

  function closeLightbox() {
    lightbox.style.display = "none";
  }

  galleryImages.forEach((img) => {
    img.addEventListener("click", () => openLightbox(img));
  });

  lightboxClose.addEventListener("click", closeLightbox);

  lightbox.addEventListener("click", (e) => {
    if (e.target !== lightboxImg && e.target !== lightboxCaption) {
      closeLightbox();
    }
  });
});
